"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ark = require("@dateam/ark");
var _react = _interopRequireDefault(require("react"));
var _CalendarContext = _interopRequireDefault(require("./CalendarContext"));
var _defaultLocale = _interopRequireDefault(require("./defaultLocale"));
const CalendarBodyHeader = () => {
  const {
    locale = _defaultLocale.default
  } = _react.default.useContext(_CalendarContext.default);
  const days = _react.default.useMemo(() => {
    if (!(0, _ark.isObjectLike)(locale)) return [];
    const labels = [...locale.dayLabelShort];

    // If weeks start on mondays, shifts the first item (expected to be Sunday label) to the end
    if (locale.weekStartOnMondays) {
      const firstDay = labels.shift();
      if (firstDay != null) labels.push(firstDay);
    }
    return labels.take(7);
  }, [locale]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "calendarBodyHeader"
  }, days.map(dayLabel => /*#__PURE__*/_react.default.createElement("span", {
    className: "calendarBodyHeaderLabel",
    key: dayLabel
  }, dayLabel)));
};
var _default = exports.default = /*#__PURE__*/_react.default.memo(CalendarBodyHeader);